import React from 'react';
import { motion } from 'framer-motion';
import { useGentleMotion as useReducedMotion } from '../hooks/useGentleMotion';
import { ArrowRightIcon } from 'lucide-react';
import { useMarket } from '../contexts/MarketContext';
import { useAddToCart } from '../hooks/useAddToCart';
interface CTAButtonProps {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  className?: string;
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  size = 'lg',
  className = '',
  fullWidth = false
}: CTAButtonProps) {
  const reduce = useReducedMotion();
  /* Same variant, quantity 1, pinned to the market the visitor saw. */
  const {
    cartHref
  } = useMarket();
  const onAddToCart = useAddToCart();
  const sizes = size === 'lg' ? 'px-8 py-4 text-base sm:text-lg' : 'px-6 py-3 text-sm sm:text-base';
  return <motion.a href={cartHref} onClick={onAddToCart} className={['group relative inline-flex items-center justify-center gap-2 rounded-2xl bg-brandgreen font-display font-extrabold uppercase tracking-wide text-white shadow-cta', 'transition-colors duration-300 hover:bg-[#26794d]', 'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-navy', sizes, fullWidth ? 'w-full' : '', className].join(' ')} animate={reduce ? undefined : {
    y: [0, -4, 0],
    boxShadow: ['0 10px 22px -8px rgba(45,140,90,0.55)', '0 18px 30px -8px rgba(45,140,90,0.6)', '0 10px 22px -8px rgba(45,140,90,0.55)']
  }} transition={{
    duration: 2.8,
    repeat: Infinity,
    ease: 'easeInOut'
  }} whileHover={reduce ? undefined : {
    scale: 1.03
  }} whileTap={reduce ? undefined : {
    scale: 0.98
  }} data-id="element-108" data-mp="3cqvsnppordfj">
      <span data-id="element-109" data-mp="2awfegnoybtom">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-300 group-hover:translate-x-1 motion-reduce:transition-none" aria-hidden="true" data-id="element-110" data-mp="2fwtogba45dpa" />
    </motion.a>;
}